module.exports = __webpack_public_path__ + "img/ic_study_default.2828204a.png";